const generateSelect = (selects) => {
    return `select ${selects
        .map(select => `${select.field} as ${select.as}`)
        .join(', ')}`;
};
const generateWhere = (where) => {
    const whereString = where.map(where => {
        var _a;
        if ('in' in where) {
            const inString = where.in.map(w => `'${w}'`).join(',');
            return `${where.field} ${(where === null || where === void 0 ? void 0 : where.not) ? 'not in' : 'in'} (${inString})`;
        }
        return `${where.field} ${(_a = where === null || where === void 0 ? void 0 : where.operator) !== null && _a !== void 0 ? _a : '='} ${where.value === null ? 'null' : `'${where.value}'`}`;
    }, '');
    return ` where ${whereString.join(' and ')}`;
};
const generateHaving = (having) => {
    if (!having)
        return '';
    const havingString = having.map(having => {
        return `${having.field} ${having.operator} ${having.value}`;
    }, '');
    return ` having ${havingString.join(' and ')}`;
};
const generateOrder = (order) => {
    if (!order)
        return '';
    const direction = order.dir === 'desc' ? ' desc' : '';
    return ` order by ${order.by}${direction}`;
};
const generateTimeFrameString = (timeFrame) => {
    if (!timeFrame)
        return '';
    if ('to' in timeFrame && 'from' in timeFrame) {
        return ` timeFrame from ${timeFrame.from} to ${timeFrame.to}`;
    }
    if ('to' in timeFrame) {
        return ` timeFrame to ${timeFrame.to}`;
    }
    if ('from' in timeFrame) {
        return ` timeFrame from ${timeFrame.from}`;
    }
};
const generateLimit = (limit) => {
    return ` limit ${limit}`;
};
const generateGroupByString = (groupBy) => {
    if (!groupBy)
        return '';
    const groupField = (groupBy === null || groupBy === void 0 ? void 0 : groupBy.field) ? `, ${groupBy.field}` : '';
    if ('each' in groupBy) {
        return ` group by each '${groupBy.each}' in '${groupBy.timeZone}'${groupField}`;
    }
    if ('every' in groupBy) {
        return ` group by every '${groupBy.every}' in '${groupBy.timeZone}'${groupField}`;
    }
    if ('field' in groupBy) {
        return ` group by ${groupBy.field}`;
    }
    return '';
};
export const generateAnalyticsQuery = ({ selects, where, limit, having, order, timeFrame, groupBy, }) => {
    const query = `${generateSelect(selects)}${generateTimeFrameString(timeFrame)}${generateWhere(where)}${generateGroupByString(groupBy)}${generateHaving(having)}${generateOrder(order)}${generateLimit(limit)}`;
    return query;
};
export const generateTimeFrame = ({ timeFrame, target = 'current', }) => {
    var _a;
    if (target === 'current') {
        return {
            from: timeFrame.from,
            ...((timeFrame === null || timeFrame === void 0 ? void 0 : timeFrame.to)
                ? {
                    to: timeFrame.to,
                }
                : {}),
        };
    }
    if (target === 'previous') {
        const from = timeFrame.from - (((_a = timeFrame === null || timeFrame === void 0 ? void 0 : timeFrame.to) !== null && _a !== void 0 ? _a : Date.now()) - timeFrame.from);
        return {
            from,
            to: timeFrame.from,
        };
    }
};
export const generateGroupBy = (granularity, step = 1) => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    switch (granularity) {
        case 'day':
            return { every: `${step}d`, timeZone };
        case 'month':
            return { each: 'month', timeZone };
        case 'hour':
            return { each: 'hour', timeZone };
        case 'dayOfWeek':
            return { each: 'day of week', timeZone };
        default:
            // Code should never reach the default case
            // eslint-disable-next-line no-case-declarations
            const exhaustiveCheck = granularity;
            return exhaustiveCheck;
    }
};
//# sourceMappingURL=generateAnalyticsQuery.js.map